export default __webpack_public_path__ + "static/media/section10-background.ccf9214b.jpg";